/**
 * Grilles tarifaires gestion — source de vérité unique
 * Importée dans gestion/accounting et gestion/packs.
 */

export const IMMO_NAF_CODES = ['6820A', '6820B', "68.20B", "68.20A"];

// --- Grille BIC : prix en fonction du CA annuel (€) ----------------------
const BIC_GRID = [
    { ca_min:       0, ca_max:   10_000, price:  79.9 },
    { ca_min:  10_000, ca_max:   20_000, price:  89.9 },
    { ca_min:  20_000, ca_max:   30_000, price:  89.9 },
    { ca_min:  30_000, ca_max:   50_000, price:  99.9 },
    { ca_min:  50_000, ca_max:   85_000, price: 109.9 },
    { ca_min:  85_000, ca_max:  120_000, price: 119.9 },
    { ca_min: 120_000, ca_max:  150_000, price: 139.9 },
    { ca_min: 150_000, ca_max:  200_000, price: 169.9 },
    { ca_min: 200_000, ca_max:  250_000, price: 219.9 },
    { ca_min: 250_000, ca_max:  300_000, price: 239.9 },
    { ca_min: 300_000, ca_max:  350_000, price: 259.9 },
    { ca_min: 350_000, ca_max:  400_000, price: 289.9 },
    { ca_min: 400_000, ca_max:  450_000, price: 309.9 },
    { ca_min: 450_000, ca_max:  500_000, price: 339.9 },
    { ca_min: 500_000, ca_max:  550_000, price: 359.9 },
    { ca_min: 550_000, ca_max:  600_000, price: 379.9 },
    { ca_min: 600_000, ca_max:  650_000, price: 409.9 },
    { ca_min: 650_000, ca_max:  700_000, price: 429.9 },
    { ca_min: 700_000, ca_max:  750_000, price: 459.9 },
    { ca_min: 750_000, ca_max:  800_000, price: 479.9 },
    { ca_min: 800_000, ca_max:  850_000, price: 499.9 },
    { ca_min: 850_000, ca_max:  900_000, price: 529.9 },
    { ca_min: 900_000, ca_max:  950_000, price: 549.9 },
    { ca_min: 950_000, ca_max: 1_000_001, price: 579.9 },
    { ca_min: 1_000_001, ca_max: 1_050_000, price: 599.9 },
    { ca_min: 1_050_000, ca_max: 1_100_000, price: 619.9 },
    { ca_min: 1_100_000, ca_max: 1_150_000, price: 649.9 },
    { ca_min: 1_150_000, ca_max: 1_200_000, price: 669.9 },
    { ca_min: 1_200_000, ca_max: 1_250_000, price: 699.9 },
    { ca_min: 1_250_000, ca_max: 1_300_000, price: 719.9 },
    { ca_min: 1_300_000, ca_max: 1_350_000, price: 739.9 },
    { ca_min: 1_350_000, ca_max: 1_400_000, price: 769.9 },
    { ca_min: 1_400_000, ca_max: 1_450_000, price: 789.9 },
    { ca_min: 1_450_000, ca_max: Infinity,  price: 819.9 },
];

// --- Grille IMMO : prix en fonction du nombre de biens --------------------
const IMMO_GRID = [
    { nb_min:  1, nb_max:  2, price:  49.9 },
    { nb_min:  3, nb_max:  5, price:  59.9 },
    { nb_min:  6, nb_max:  8, price:  69.9 },
    { nb_min:  9, nb_max: 10, price:  79.9 },
    { nb_min: 11, nb_max: 12, price:  89.9 },
    { nb_min: 13, nb_max: 14, price:  99.9 },
    { nb_min: 15, nb_max: 16, price: 109.9 },
    { nb_min: 17, nb_max: 18, price: 119.9 },
    { nb_min: 19, nb_max: Infinity, price: 129.9 },
];

// --- Helpers publics -------------------------------------------------------

/** Indique si le code NAF correspond à une société immobilière */
export function isImmoNaf(codeNaf) {
    return IMMO_NAF_CODES.includes(codeNaf);
}

/**
 * Retourne le prix Premium HT mensuel selon la grille.
 * - Sociétés IMMO : tarification au nombre de biens
 * - Autres (BIC)  : tarification au CA annuel
 */
export function premiumPriceFor({ ca, codeNaf, nbBiens }) {
    if (isImmoNaf(codeNaf)) {
        const nb    = parseInt(nbBiens) || 1;
        const entry = IMMO_GRID.find(e => nb >= e.nb_min && nb <= e.nb_max);
        return entry ? entry.price : IMMO_GRID[IMMO_GRID.length - 1].price;
    }

    const caNum = parseFloat(ca) || 0;
    const entry = BIC_GRID.find(e => caNum >= e.ca_min && caNum < e.ca_max);
    return entry ? entry.price : BIC_GRID[BIC_GRID.length - 1].price;
}

/**
 * Retourne les 3 tiers de prix à partir du prix Premium.
 *   Premium   = grille
 *   Standard  = Premium - 10
 *   Débutant  = Premium - 20  ← affiché sur gestion/accounting (prix minimum)
 */
export function tierPrices(premiumPrice) {
    return {
        premium:  premiumPrice,
        standard: Math.max(parseFloat((premiumPrice - 10).toFixed(1)), 0),
        debutant: Math.max(parseFloat((premiumPrice - 20).toFixed(1)), 0),
    };
}
